import { Injectable } from '@angular/core';
import { FormsAssociationSettingsApiService, NrdsAssociationsApiService } from '@tangilla/tg-ng-core';
import { RequestParameters } from '@tangilla/tg-ng-models';
import { firstValueFrom } from 'rxjs';
import { ErrorsService } from './errors.service';
import { SurveyService } from '../survey/survey.service';

@Injectable({
  providedIn: 'root'
})
export class NrdsUtilsService {
  constructor(
    private surveyService: SurveyService,
    private errorsService: ErrorsService,
    private nrdsAssociationsApiService: NrdsAssociationsApiService,
    private formsAssociationApiService: FormsAssociationSettingsApiService) {
  }

  async checkNrdsService() {
    /*
        if (ENV === 'development') {
          console.log('NRDS not checked');
          return false;
        }
    */
    try {
      await firstValueFrom(this.nrdsAssociationsApiService.getAll((new RequestParameters(null)).setAdditionalFields({association_nrds_id: '0001'})));

      const formsAssociationSettingsResponse = await firstValueFrom(this.formsAssociationApiService.get());
      if (formsAssociationSettingsResponse?.under_maintenance) {
        return this.showNrdsServiceError();
      }
      
      return true;
    } catch (error) {
      return this.showNrdsServiceError();
    }
  }

  private showNrdsServiceError() {
    const formSource = (hasCaps: boolean) => this.surveyService.formSource ? `${hasCaps ? 'T' : 't'}he ${this.surveyService.formSource}` : `${hasCaps ? 'T' : 't'}his form`;

    setTimeout(function () {
      location.reload();
    }, 30000);
    this.errorsService.exitForm(`${formSource(true)} is Currently Unavailable`, `You can leave this window open and the page will refresh automatically when ${formSource(false)} is available again.`);
    return false;
  }
}
